import { put, takeLatest } from "redux-saga/effects";
import { getMenuProductBrandsApi } from "store/api/OrderApi";
import { GET_MENU_PRODUCT_BRANDS_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getMenuProductBrands(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getMenuProductBrandsApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(orderPageAction.setMenuProductBrandsAction(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getMenuProductBrandsSaga() {
	yield takeLatest(GET_MENU_PRODUCT_BRANDS_ACTION, getMenuProductBrands);
}

export default getMenuProductBrandsSaga;
